import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import noPicture from 'images/nopic.jpg'
import { apiImageUrl, urlName } from 'lib/utils'
import ArticlePrice from '../ArticlePrice'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/image-gallery.css'
import {
  addToCart
} from 'features/ShoppingCart/duck'
import {
  formatDeliveryDate
} from 'lib/utils'
import './style.scss'

class ArticleInfo extends Component {
  static propTypes = {
    article: PropTypes.object.isRequired,
    lng: PropTypes.object.isRequired,
    productgroups: PropTypes.array.isRequired,
    orderMonthsEN: PropTypes.string,
    orderMonthsSV: PropTypes.string,
    orderMonthsSeasonEN: PropTypes.string,
    orderMonthsSeasonSV: PropTypes.string,
    currentLanguage: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props)
    this.downloadRef = React.createRef()
    this.galleryRef = React.createRef()
    const imageIds = props.article.ImageIds && props.article.ImageIds.length > 0
      ? props.article.ImageIds
      : (props.article.ImageId ? [props.article.ImageId] : [])
    this.imageIds = imageIds
    this.galleryItems = imageIds.length > 0
      ? imageIds.map(id => ({
        original: apiImageUrl('ArticleImage', id),
        thumbnail: apiImageUrl('ArticleThumbnail', id),
        fullscreen: apiImageUrl('ArticleImageFull', id)
      }))
      : [{ original: noPicture }]
    this.state = {
      addQuantities: [],
      articleGroup: {}
    }
  }

  stockStatus = () => {
    let stockstatus
    let suffix = this.props.currentLanguage === 'en' ? 'pcs' : 'st'

    if (this.props.article.QuantityAvailable > 100) {
      return stockstatus = `100  ${suffix}+`
    } else if (this.props.article.QuantityAvailable > 0) {
      stockstatus = `${this.props.article.QuantityAvailable} ${suffix} `
    } else if (this.props.article.QuantityAvailable + this.props.article.OrderedArticles > 0 && this.props.article.EstimatedDeliveryDate) {
      stockstatus = formatDeliveryDate(this.props.article.EstimatedDeliveryDate)
    } else if (this.props.article.QuantityAvailable + this.props.article.OrderedArticles > 0) {
      stockstatus = this.props.lng.Common.Ordered
    } else if (this.props.article.NoArticleStock) {
      if (this.props.currentLanguage === 'en')
        stockstatus = this.props.article.SeasonNews ? this.props.orderMonthsSeasonEN : this.props.orderMonthsEN
      else if (this.props.currentLanguage === 'sv')
        stockstatus = this.props.article.SeasonNews ? this.props.orderMonthsSeasonSV : this.props.orderMonthsSV
    } else {
      stockstatus = this.props.lng.Common.SoldOut
    }
    return stockstatus
  }

  onClickImage = () => {
    if (this.galleryRef.current) {
      this.galleryRef.current.toggleFullScreen()
    }
  }

  onSlide = (currentIndex) => {
    const id = this.imageIds[currentIndex]
    if (this.downloadRef.current && id) {
      this.downloadRef.current.href = apiImageUrl('ArticleImageFull', id)
    }
  }

  onAddToCart = () => {
    this.props.dispatch(addToCart(this.props.article.Id, this.state.quantity))
  }

  onChange = (e) => {
    const {
      name,
      value
    } = e.target

    this.setState({
      [name]: Number(value)
    })
  }

  componentWillMount() {
    let addQuantities = []
    for (let i = 1; i <= 10; i++) {
      addQuantities.push(this.props.article.QuantityPerPackage * i)
    }

    let articleGroup = {}
    if (this.props.productgroups) {
      articleGroup = this.props.productgroups.find(group => group.ProductGroupId === this.props.article.ProductGroupId)
    }

    this.setState({
      addQuantities,
      articleGroup,
      quantity: addQuantities[0]
    })
  }

  render() {
    const {
      lng,
      article,
      account
    } = this.props

    const articleGroup = this.state.articleGroup || {}

    const hasImages = this.imageIds.length > 0
    const fullImageURL = hasImages ? apiImageUrl('ArticleImageFull', this.imageIds[0]) : ''
    const articleGroupUrl = `/products/${articleGroup.ProductGroupId}/` + urlName(articleGroup.Name || '')

    return (
      <div className="articleContainer row">
        <div className="imageContainer col-sm-5 col-xs-12">
          <ImageGallery
            ref={this.galleryRef}
            items={this.galleryItems}
            showThumbnails={this.imageIds.length > 1}
            showPlayButton={false}
            showFullscreenButton={false}
            showNav={this.imageIds.length > 1}
            useBrowserFullscreen={false}
            onClick={this.onClickImage}
            onSlide={this.onSlide}
          />
          {hasImages && (
            <a ref={this.downloadRef} className="downLoadImage" href={fullImageURL}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              {lng.Product.DownloadHiRes}
            </a>
          )}
        </div>

        <div className="productInfo col-sm-7 col-xs-12">
          <div className="header">
            <h2>{article.ArticleText} </h2>
            <div className="subTitle">Artikelnummer: {article.ArticleNumber} </div>
          </div>
          <div className="productGroup">
            <label htmlFor="">{lng.Product.ArticleGroup}: </label>
            <Link to={articleGroupUrl}>{articleGroup.Name}</Link>
          </div>
          {
            article.EAN ?
              <div>
                <label htmlFor="">{lng.Product.EANCode}: </label>
                <span>{article.EAN}</span>
              </div> : null
          }
          <div>
            <label htmlFor="">{lng.Product.PackageQuantity}: </label>
            <span>{article.QuantityPerPackage} st.</span>
          </div>
          <div>
            <label htmlFor="">{lng.Product.PackageSize}: </label>
            <span>{article.BoxWidth}x{article.BoxHeight}x{article.BoxDepth}</span>
          </div>
          <div>
            <label htmlFor="">{lng.Product.PackageWeight}: </label>
            <span>{article.Weight} kg</span>
          </div>
          <div>
            <label htmlFor="">{lng.Product.StockStatus}: </label>
            <span>{this.stockStatus()}</span>
          </div>
          <div className="productDescription">
            <label>{lng.Common.Description}</label>
            <p>{article.Description}</p>
          </div>
          {
            account.loggedIn && <ArticlePrice
              article={article}
              lng={lng}
              addQuantities={this.state.addQuantities}
              quantity={this.state.quantity}
              onChange={this.onChange}
              addToCart={this.onAddToCart} />
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  account: state.user.login
})



export default connect(mapStateToProps)(ArticleInfo)
